/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { MenuItem, Select, Typography } from "@mui/material";
import { ImageInPageEditorV2 } from "cms/images/image-inpage-editor-v2";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { SimplicityComposerEnsureTipTap } from "cms/rich-text/simplicity-composer-tiptap";
import { useState } from "react";

const RichTextWithImageComponentEditor = () => {

    const disableScale = true;
    const { component, update, updateFactory } = useUpdateComponent();
    const side = component?.side ?? "left";
    const richtext = component?.richtext;
    const _image = component?.image;
    const _settings = component?.settings;
    
    const [image,setImage] = useState(_image);
    const [settings,setSettings] = useState(_settings);
    
    const onChangeImageWithSettings = (_image, settings) => {
        const guid = _image?.guid;
        setImage(image);
        setSettings(settings);
        update("image", guid);
        update("settings", settings);
    };
    
    const updateSide = (event) => {
        const nextSide = event.target.value;
        update("side", nextSide);
    };
    const onRemoveImage = () => {
        update("image", undefined);
    };

    const updateRichText = updateFactory("richtext");
    
    return (
        <div className='simplicity-editor-frame'>
            <Typography variant='overline' color={"text.secondary"}>
                Rich Text:{" "}
            </Typography>
            <SimplicityComposerEnsureTipTap
                richtext={richtext}
                onChange={updateRichText}
            />

            <Typography variant='overline' color={"text.secondary"}>
                Image:{" "}
            </Typography>
            
            <ImageInPageEditorV2
                image_guid={image}
                settings={settings}
                onChangeImageWithSettings={onChangeImageWithSettings}
                onRemoveImage={onRemoveImage}
                disableScale={disableScale}
            />

            <Typography variant='overline' color={"text.secondary"}>
                Side:{" "}
            </Typography>
            <Select
                labelId='image_side'
                id='image_side'
                value={side}
                onChange={updateSide}
                style={{ width: "100%" }}
            >
                <MenuItem value='left'><em>Left</em></MenuItem>
                <MenuItem value='right'>Right</MenuItem>
            </Select>
            

        </div>
    );
};

RichTextWithImageComponentEditor.displayName = "RichTextWithImageComponentEditor";
export { RichTextWithImageComponentEditor };
